'use client';
import React from 'react';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'bi-globe',
      title: 'Pan India Coverage',
      description: 'Our services extend across Gujarat and all over India, meeting workforce needs for diverse industries and sectors.',
      delay: 200,
    },
    {
      icon: 'bi-person-check',
      title: 'Skilled & Verified Workforce',
      description: 'We supply thoroughly verified and experienced manpower for various government tenders and private contracts.',
      delay: 300,
    },
    {
      //icon: 'bi-broadcast',
      icon:'bi-hourglass-split',
      title: 'Timely Deployment',
      description: 'We understand urgency. Our team ensures prompt deployment and onboarding to avoid project delays.',
      delay: 400,
    },
    {
      icon: 'bi-people',
      title: 'Custom Manpower Solutions',
      description: "Whether it's short-term, long-term, or contract-based hiring — we tailor solutions as per client requirements.",
      delay: 500,
    },
  ];

  return (
    <section id="features" className="features section">
      <div className="container">
        <div className="row gy-4">
          <div className="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <img src="/assets/img/features-bg.jpg" alt="Features" />
          </div>
          <div className="col-lg-6">
            {features.map((feature, index) => (
              <div
                className={`features-item d-flex ${index !== 0 ? 'mt-5' : ''} ps-0 ps-lg-3 pt-4 pt-lg-0`}
                data-aos="fade-up"
                data-aos-delay={feature.delay}
                key={index}
              >
                <i className={`bi ${feature.icon} flex-shrink-0`}></i>
                <div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
